import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AuthService } from "../../auth.service";
import { Router } from "@angular/router";
import { IUser, User } from "../../users/user";
import { AppCommonService } from "../../appcommon.service";
import { HeaderAndNavigationService } from "../headerandnavigation.service";
import { ILoggedUser } from "./loggeduser";
import { SendEnquiry } from "./sendenquiry";
import { GlobalService } from "../../global.service";
import { LoaderService } from "../../LoaderService";
import { CookieService } from 'ngx-cookie-service';
@Component({
    selector:'[mft-logout]',
    templateUrl:'./loggeduser.component.html'
})
export class LoggedUserComponent implements OnInit 
{
    loggedUser:ILoggedUser;
    enquiryForm: FormGroup;
    sendEnquiry: SendEnquiry = new SendEnquiry();
    errorMessage: string;
    public loading = false;
    mftAccessToken: string = "mftAccessToken";
    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        public headerAndNavigationService: HeaderAndNavigationService,
        private appCommonService: AppCommonService,
        private router: Router,
        private cookieService: CookieService,
        public globalService: GlobalService,
        public loaderService: LoaderService
    ) { }

    ngOnInit(): void {
        this.enquiryForm = this.fb.group({          
          EnquiryDetail: ['', [Validators.required]]
        });

        this.loggedUser = this.headerAndNavigationService.getLoggedUser();
        if (this.loggedUser == null) {
          this.headerAndNavigationService.RedirectToLogin();
        }
        //this.headerAndNavigationService.getLoggedUser()
        //.subscribe(
        //    (user:ILoggedUser) => {
        //        this.loggedUser = user;
        //    },
        //    (error: any) => {                
        //      this.globalService.showError("Logged user retrieval problem", <any>error);
        //      this.headerAndNavigationService.RedirectToLogin();
        //    }
        //);
    }

    //logOut(): void{
    //    this.headerAndNavigationService.logOut();        
    //}

   logOut(): void {
      this.headerAndNavigationService.ClearUserData();
      this.authService.logout();
    }

    OnSendEnquiry(): void {
      if (this.enquiryForm.dirty && this.enquiryForm.valid) {
        // Copy the form values over the product object values        
        this.sendEnquiry.Email = this.loggedUser.email;
        this.sendEnquiry.FullName = this.loggedUser.name;
        let p = Object.assign({}, this.sendEnquiry, this.enquiryForm.value);        
        this.loaderService.display(true);
        this.headerAndNavigationService.sendEnquiry(p)
          .subscribe(
          () => {
            this.globalService.showSuccess("Enquiry", "submitted successfully.");
            this.onEnquiryComplete();            
            this.loaderService.display(false);
          },
          (error: any) => {
            this.loaderService.display(false);
            this.globalService.showError("Enquiry", <any>error)
          }
          );
      } else if (!this.enquiryForm.dirty) {
        this.onEnquiryComplete();
      }
    }

    onEnquiryComplete(): void {
      // Reset the form to clear the flags
      this.enquiryForm.reset();
      this.errorMessage = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/loggeduser/loggeduser.component.ts